export default __webpack_public_path__ + "assets/single-img-17_1single-img-17.bda85d47.avif";